import types from './types';

function reducer(state = '', action) {
  switch (action.type) {
    case types.SET_ROW:
      return Object.assign({}, state, { [action.key]: action.row });
    default:
      return state;
  }
}

export default reducer;
